import axios from 'axios';

// Path relativo: frontend e backend sono dietro lo stesso nginx (sia dev che prod),
// con `/api/*` proxied al backend. Niente NEXT_PUBLIC_API_URL → niente sostituzioni
// bundler-dependent (es. Turbopack che lascia placeholder in dev).
const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

// Aggiunge il Bearer token ad ogni richiesta
api.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('accessToken');
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Se 401 → prova refresh, altrimenti logout
// Se 403 con code=TOTP_SETUP_REQUIRED → redirect a setup 2FA obbligatorio
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status   = error.response?.status;
    const code     = error.response?.data?.code;

    if (status === 403 && code === 'TOTP_SETUP_REQUIRED' && typeof window !== 'undefined') {
      if (!window.location.pathname.startsWith('/setup-2fa-obbligatorio')) {
        window.location.href = '/setup-2fa-obbligatorio';
      }
      return Promise.reject(error);
    }

    // Gli endpoint di autenticazione (login, ecc.) gestiscono da soli i propri 401
    // (credenziali errate, codice 2FA richiesto/non valido): non devono far scattare
    // il rinnovo automatico della sessione né il redirect a /login.
    const isAuthEndpoint = String(original?.url ?? '').includes('/auth/');

    if (status === 401 && !original._retry && !isAuthEndpoint) {
      original._retry = true;
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) throw new Error('no refresh token');
        const { data } = await axios.post('/api/auth/refresh', { refreshToken });
        localStorage.setItem('accessToken', data.accessToken);
        original.headers['Authorization'] = `Bearer ${data.accessToken}`;
        return api(original);
      } catch {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
